import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux/index';
import { connect } from 'react-redux';
import PageLoader from 'components/page-loader';
import mapFacets from 'util/react/facet';
import classnames from 'classnames';

class MainContent extends Component {
    static defaultProps = {
        facet: [],
        isWrapped: true,
        isLoaderVisible: false,
    };

    static propTypes = {
        children: PropTypes.any,
        facet: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
        isWrapped: PropTypes.bool.isRequired,
        isLoaded: PropTypes.bool.isRequired,
        isLoaderVisible: PropTypes.bool.isRequired,
    };

    render() {
        const { children, isLoaded, facet, isWrapped, isLoaderVisible, dispatch, ...props } = this.props; // eslint-disable-line
        const layoutFacet = mapFacets(facet, 'layout--grid-container');

        return (
            <main {...props}>
                <div
                    className={classnames('layout--grid-container', isWrapped ? 'grid--container' : null, layoutFacet)}>
                    {isLoaderVisible && <PageLoader useRandomIcon={true}/>}
                    <div className={classnames('layout--page-container', {
                        'layout--page-container__is-loaded': isLoaded,
                    })}>
                        {children}
                    </div>
                </div>
            </main>
        );
    };
}


export default connect(
    reduxUtils.mapStateToProps({
        isLoaded: 'main-content.isLoaded',
        isLoaderVisible: 'main-content.isLoaderVisible',
    }),
)(MainContent);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/containers/main-content.js